module.exports = __webpack_public_path__ + "img/full6-min.573bd03e.png";